(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var textLineCount = 3;

  function textLineBottom(root, count) {
    var range = document.createRange();
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var seen = 0;
    var lastTop = null;
    var rootTop = root.getBoundingClientRect().top;

    while (walker.nextNode()) {
      range.selectNodeContents(walker.currentNode);
      var rects = range.getClientRects();
      for (var i = 0; i < rects.length; i++) {
        var rect = rects[i];
        if (rect.width < 1 || rect.height < 1) continue;
        if (lastTop !== null && Math.abs(rect.top - lastTop) <= 2) continue;
        seen += 1;
        lastTop = rect.top;
        if (seen >= count) return Math.ceil(rect.bottom - rootTop);
      }
    }

    return null;
  }

  function setup(wrapper) {
    var description = wrapper.querySelector('[data-artist-description]');
    var toggle = wrapper.querySelector('[data-artist-description-toggle]');
    if (!description || !toggle) return;

    var expandLabel = toggle.querySelector('[data-toggle-label-expand]');
    var collapseLabel = toggle.querySelector('[data-toggle-label-collapse]');
    var expandIcon = toggle.querySelector('[data-toggle-icon-expand]');
    var collapseIcon = toggle.querySelector('[data-toggle-icon-collapse]');

    function showPair(expanded) {
      if (expandLabel) expandLabel.hidden = expanded;
      if (expandIcon) expandIcon.hidden = expanded;
      if (collapseLabel) collapseLabel.hidden = !expanded;
      if (collapseIcon) collapseIcon.hidden = !expanded;
    }

    function setExpanded(expanded) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      showPair(expanded);
      description.classList.remove('is-collapsed');
      description.style.maxHeight = '';
      if (!expanded) {
        description.classList.add('is-collapsed');
        description.style.maxHeight = textLineBottom(description, textLineCount) + 'px';
      }
    }

    function checkOverflow() {
      description.classList.remove('is-collapsed');
      description.style.maxHeight = '';

      if (!mobileQuery.matches) {
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        showPair(false);
        return;
      }

      var collapsedHeight = textLineBottom(description, textLineCount);
      if (!collapsedHeight || description.scrollHeight <= collapsedHeight + 10) {
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        return;
      }

      toggle.hidden = false;
      setExpanded(toggle.getAttribute('aria-expanded') === 'true');
    }

    toggle.addEventListener('click', function () {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', checkOverflow);
    }

    checkOverflow();
  }

  document.querySelectorAll('[data-artist-description-wrapper]').forEach(setup);
})();
